import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { MobileBottomNav } from './MobileBottomNav';
import { MobileDrawer } from './MobileDrawer';

export const PublicLayout: React.FC = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <div className="min-h-screen flex flex-col bg-editorial-parchment text-editorial-ink antialiased">
      <Navbar onOpenMobileDrawer={() => setDrawerOpen(true)} />
      
      {/* Main Content Area with padding at bottom for Android Bottom Nav */}
      <main className="flex-grow pb-24 md:pb-0">
        <Outlet />
      </main>

      <Footer />

      {/* Android Mobile Navigation & Bottom Drawer */}
      <MobileBottomNav onOpenDrawer={() => setDrawerOpen(true)} />
      <MobileDrawer isOpen={drawerOpen} onClose={() => setDrawerOpen(false)} theme="light" />
    </div>
  );
};
